<template>
  <a-card>
    <a-collapse v-model="activeKey" :bordered="false">
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel v-for="(item, index) in data" :key="`${index}`" :header="item.release_title" class="custom-collapse">
        <div style="margin-top: 8px">
          <vditor-preview :content="item.context" />
        </div>
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>

<script>
import VditorPreview from '@/components/VditorEditor/preview';
export default {
  components: { VditorPreview },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    activeKey() {
      return this.data.map((item, index) => {
        return `${index}`;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.custom-collapse {
  background: #ffffff;
  border: 0;
  overflow: hidden;
  .ant-collapse-header {
    background: #fafafa;
  }
  .ant-collapse-content-box {
    padding: 32px;
  }
}
/deep/.ant-card-body {
  padding: 16px;
}
</style>
